import {
  MOENGAGE_EVENT_NAME,
  toMoengageAttributeKey,
} from "@hightouch/lib/customer-data/decision-engine/destination-definitions/moengage-attribute-key";
import type { DecisionEngineDestinationUI } from "./definition";

const VARIABLE_REFERENCE_PREFIX = "hightouch.recommendation.variables.";

export const moengageUI: DecisionEngineDestinationUI = {
  campaignSetup: "event-triggered",
  resourceName: "flow",
  channelDescription: "MoEngage",
  /**
   * The `MOE_TRIGGER_EVENT.` prefix pins personalization to the event that
   * triggered the flow. Without it MoEngage resolves the user's most recent
   * occurrence of the event, which is the wrong message when two AI
   * Decisioning sends land close together.
   * https://help.moengage.com/hc/en-us/articles/115005552086-Personalization-in-Flows
   */
  getReferenceString: (reference) => {
    const name = reference.startsWith(VARIABLE_REFERENCE_PREFIX)
      ? reference.slice(VARIABLE_REFERENCE_PREFIX.length)
      : reference;
    return `{{EventAttribute['MOE_TRIGGER_EVENT.${MOENGAGE_EVENT_NAME}.${toMoengageAttributeKey(name)}']}}`;
  },
  isInactive: () => true,
  isPreviewSupported: false,
  getResourceType: () => null,
  getEmailPreviewMethod: "e2e",
  isTestSendSupported: true,
  showAssociatedTemplate: false,
};
